import { OData } from '@common/api/qs';

export class ODataAuth extends OData
{
    constructor (incrSize: number, type?: boolean)
    {
        super(incrSize);

        this.values.push({ key: 'external', value: type });
        this.qs = this.getQueryString()??'';
    }
}
